import { render, staticRenderFns } from "./KkvTeaser.vue?vue&type=template&id=57354309"
import script from "./KkvTeaser.vue?vue&type=script&lang=js"
export * from "./KkvTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports